module.exports = __webpack_public_path__ + "line.567f57385ea3dde2c9ae.gif";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/primeng/resources/images/line.gif
// module id = ../../../../primeng/resources/images/line.gif
// module chunks = 2